/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/

import { observer } from 'mobx-react';
import * as React from 'react';

import { labelGroup } from '../utilities/order-lookup-utility';

/**
 * Additional input field props.
 */
export interface IOrderLookupAdditionalFieldInfoInput {
    className: string;
    ariaLabel: string;
    inputType: string;
    value: string;
    name: string;
    additionalFieldLabel: string;
    additionalFieldLabelClassName: string;
    isValidAdditionalFieldName: boolean;
    additionalFieldValidationMessage: string;
    onChange(event: React.ChangeEvent<HTMLInputElement>): void;
}

/**
 * Order lookup additional field props.
 */
export interface IOrderLookupAdditionalFieldInfo {
    additionalFieldLabel: React.ReactNode;
    additionalFieldInput: React.ReactNode;
    additionalFieldError: React.ReactNode;
}

/**
 * RenderOrderLookupAdditionalFieldInput component.
 */
@observer
export default class RenderOrderLookupAdditionalFieldInput extends React.Component<IOrderLookupAdditionalFieldInfoInput> {
    public constructor(props: IOrderLookupAdditionalFieldInfoInput) {
        super(props);
    }

    public shouldComponentUpdate(nextProps: IOrderLookupAdditionalFieldInfoInput): boolean {
        if (this.props === nextProps) {
            return false;
        }
        return true;
    }

    public render(): JSX.Element | undefined {
        return (
            <div className='ms-order-lookup__details__form__additional-fields'>
                {this._getOrderLookupAdditionalFields().additionalFieldLabel}
                {this._getOrderLookupAdditionalFields().additionalFieldError}
                {this._getOrderLookupAdditionalFields().additionalFieldInput}
            </div>
        );
    }

    /**
     * Function to create the order lookup additional fields.
     * @returns IOrderLookupFieldInfo.
     */
    private _getOrderLookupAdditionalFields(): IOrderLookupAdditionalFieldInfo {
        return {
            additionalFieldLabel: (
                labelGroup(this.props.additionalFieldLabelClassName, this.props.additionalFieldLabel)
            ),
            additionalFieldInput: (
                <div className='ms-order-lookup__details__form__additional-fields__input-detail'>
                    <input
                        type={this.props.inputType}
                        onChange={this.props.onChange}
                        aria-label={this.props.ariaLabel}
                        value={this.props.value}
                        name={this.props.name}
                    />
                </div>
            ),
            additionalFieldError: (
                <div className='ms-order-lookup__details__form__additional-fields__input-error'>
                    {!this.props.isValidAdditionalFieldName ? this.props.additionalFieldValidationMessage : ''}
                </div>
            )
        };
    }
}
